export default {
    // KPI message IDs must maintain backward compatibility for notes
    indicators: {
        CV: {
            id: 'patientResults.kpi.CV'
        },
        GMI: {
            id: 'patientResults.kpi.GMI'
        },
        average: {
            id: 'patientResults.kpi.average'
        },
        averagePreMeal: {
            id: 'patientResults.kpi.averagePreMeal'
        },
        averagePostMeal: {
            id: 'patientResults.kpi.averagePostMeal'
        },
        avgReadings: {
            id: 'patientResults.dailyReport.averageDay'
        },
        daysWithoutReading: {
            id: 'patientResults.dailyReport.daysWithoutReading'
        },
        standardDeviation: {
            id: 'patientResults.kpi.standardDeviation'
        },
        totalReadings: {
            id: 'patientResults.dailyReport.readings'
        },
        veryLow: {
            id: 'patientResults.kpi.veryLow'
        },
        veryHigh: {
            id: 'patientResults.kpi.veryHigh'
        }
    }
};
